module.exports = __webpack_public_path__ + "static/media/add_org.ff5034a0.PNG";